import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AudioPlayerModul = _resolveComponent("AudioPlayerModul")!
  const _component_MiniAudioInformer = _resolveComponent("MiniAudioInformer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default"),
    _createVNode(_component_AudioPlayerModul, {
      ref: "audio-player-modul",
      onCollapse: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInformer = true)),
      onHide: _cache[1] || (_cache[1] = ($event: any) => (_ctx.destroyedPlayer, (_ctx.showInformer = false)))
    }, null, 512),
    (_ctx.currentTrack && _ctx.showInformer)
      ? (_openBlock(), _createBlock(_component_MiniAudioInformer, {
          key: 0,
          track: _ctx.currentTrack,
          progress: _ctx.progress,
          isPlaying: _ctx.isPlaying,
          onTogglePlayback: _ctx.togglePlayback,
          onSlidebarOpen: _ctx.slidebarOpen
        }, null, 8, ["track", "progress", "isPlaying", "onTogglePlayback", "onSlidebarOpen"]))
      : _createCommentVNode("", true)
  ], 64))
}